import { getHeaders } from '../utils';

export async function APIGetCommunities() {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/communities`, requestOptions);
    const responseText = await response.json();

    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}
